import service from "@/utils/request";

// 体验课列表
export interface getExperienceLessonListData {
  page: number;
  page_size: number;
  student_id?: number;
  teacher_id?: number;
  course_id?: number;
  class_id?: number;
  follow_staff_id?: number;
  experience_status?: number;
  start_date: string;
  end_date: string;
  pay_status?: number;
  create_start_date?: string;
  create_end_date?: string;
  experience_status_arr?: [];
  source_type?: number;
  appear_id?: number;
  time_tag?: string;
  order_no?: number;
  course_type?: number;
}
export const getExperienceLessonListApi = (
  data: getExperienceLessonListData
) => {
  return service({
    url: "/api/v1/class/lesson/experience/list",
    method: "post",
    data,
  });
};

// 反馈内容
export interface getExperienceFeedbackData {
  experience_id: number;
  content: string;
}
export const getExperienceFeedbackApi = (data: getExperienceFeedbackData) => {
  return service({
    url: "/api/v1/class/lesson/experience/feedback",
    method: "post",
    data,
  });
};

// 取消体验
export interface cancelExperienceData {
  experience_id: number;
  content: string;
}
export const cancelExperienceApi = (data: cancelExperienceData) => {
  return service({
    url: "/api/v1/class/lesson/experience/cancel",
    method: "post",
    data,
  });
};

// 添加体验课次
export interface createExperienceData {
  student_ids: number[];
  course_id: number;
  teacher_ids: number[];
  main_teacher_id: number;
  lesson_type: number;
  start_time: string;
  end_time: string;
  date: string;
  classroom_id?: number;
}
export const createExperienceApi = (data: createExperienceData) => {
  return service({
    url: "/api/v1/class/lesson/experience/add",
    method: "post",
    data,
  });
};

// 体验课记录导出
export const experienceListExport = (data: getExperienceLessonListData) => {
  return service({
    url: "/api/v1/class/lesson/experience/list_export",
    method: "post",
    data,
  });
};
